import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Row, Col, Button } from 'react-bootstrap';

export default function NotFound() {

  const navigate = useNavigate();

  return (
    <Row style={{ justifyContent: 'center' }}>
      <Row style={{ flexDirection: 'row', justifyContent: 'center', alignItems: 'center', minHeight: '80vh' }}>
        <Col xs={9} sm={7} md={5} lg={5} xl={4} style={{ textAlign: 'center' }}>
          <h3 style={{ color: '#EEEEEE' }}>Page not found</h3>
          <Button style={{ marginTop: 20 }} href="https://moleculeclimate.com">Go to homepage</Button>
        </Col>
      </Row>
    </Row>
  )

}
